"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _actions = require("settings-ui-sdk/Sitemaps/actions");

var _immutable = require("immutable");

var _constants = require("settings-ui-sdk/Sitemaps/constants");

var properties = [{
  type: _PropertyTypes.default.ORDERED_MAP,
  key: _constants.INCLUDED_PAGES
}, {
  type: _PropertyTypes.default.ORDERED_MAP,
  key: _constants.EXCLUDED_PAGES
}, {
  type: _PropertyTypes.default.ORDERED_MAP,
  key: _constants.CONTENT_OPTIONS
}];
var UpdateSitemapsSettings = new _StagedObject.default({
  domainSelector: function domainSelector() {
    var _fromJS;

    return (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _constants.INCLUDED_PAGES, (0, _immutable.OrderedMap)()), (0, _defineProperty2.default)(_fromJS, _constants.EXCLUDED_PAGES, (0, _immutable.OrderedMap)()), (0, _defineProperty2.default)(_fromJS, _constants.CONTENT_OPTIONS, (0, _immutable.OrderedMap)()), _fromJS));
  },
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing[_UrlPathParams.DOMAINS].staging.updateSitemapsSettings;
  },
  requestSuccessActionType: _actions.FetchSitemapsActionTypes.SUCCESS,
  requestSuccessDataSelector: function requestSuccessDataSelector() {
    var _fromJS2;

    return (0, _immutable.fromJS)((_fromJS2 = {}, (0, _defineProperty2.default)(_fromJS2, _constants.INCLUDED_PAGES, (0, _immutable.OrderedMap)()), (0, _defineProperty2.default)(_fromJS2, _constants.EXCLUDED_PAGES, (0, _immutable.OrderedMap)()), (0, _defineProperty2.default)(_fromJS2, _constants.CONTENT_OPTIONS, (0, _immutable.OrderedMap)()), _fromJS2));
  },
  namespace: _UrlPathParams.DOMAINS,
  objectType: _UrlPathParams.DOMAINS + "/SitemapsSettings",
  properties: properties
});
var _default = UpdateSitemapsSettings;
exports.default = _default;
module.exports = exports.default;